
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link } from '@ta-interaktiv/contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Zwei Wochen nach ihrer Geburt zieht Erika mit anderen Kälbern in die Kälberbucht und erhält das Sedativum Xylazin
in die Hinterbackenmuskulatur gespritzt. Es sorgt dafür, dass ihr Schmerzempfinden gelindert wird. Zehn Minuten später
setzt der Landwirt selber jeweils ungefähr 15 Sekunden lang einen Brennstab an Erikas Hornansätze. Erika gehört zu den
90 Prozent der Kälber in der Schweiz, die enthornt werden. Erika hat nun ein kleineres Risiko, sich selber und andere
Tiere zu verletzen. Jedoch leidet sie während und auch noch Monate nach dem Eingriff unter Schmerzen, wie eine `}<Link url='https://www.schweizerbauer.ch/tiere/tiergesundheit/enthornen-kaelber-leiden-monate-44033.html' mdxType="Link">{`
Studie der Universität Bern`}</Link>{` zeigt.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;